import { html } from '@webtides/element-js';

/**
 * Renders a looping, muted background video that covers its container.
 * Under `prefers-reduced-motion` autoplay/loop are disabled so it shows a static frame (poster).
 *
 * @param {string} src - Video URL (or root-relative path)
 * @param {Object} [options]
 * @param {string} [options.poster] - Poster image shown before playback / under reduced motion
 * @param {string} [options.cssClass] - Classes applied to the <video> element
 */
export function backgroundVideo(src, { poster = '', cssClass = 'w-full h-full object-cover' } = {}) {
    if (!src) return '';

    const prefersReducedMotion =
        typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    return html`
        <video
            class="${cssClass}"
            muted
            playsinline
            ?autoplay="${!prefersReducedMotion}"
            ?loop="${!prefersReducedMotion}"
            preload="${prefersReducedMotion ? 'auto' : 'metadata'}"
            poster="${poster}"
        >
            <source src="${src}" />
        </video>
    `;
}
